
import BaseSpinner from "@/components/base/BaseSpinner.vue";
import BookingHeader from "@/components/bookingflow/BookingHeader.vue";
import Charity from "@/components/bookingflow/steps/checkout/Charity.vue";
import Details from "@/components/bookingflow/steps/checkout/Details.vue";
import Insurance from "@/components/bookingflow/steps/checkout/insurance/Insurance.vue";
import Newsletter from "@/components/bookingflow/steps/checkout/Newsletter.vue";
import Terms from "@/components/bookingflow/steps/checkout/Terms.vue";
import useCalculatePriceEffect from "@/composables/useCalculatePriceEffect";
import useCharity from "@/composables/useCharity";
import useDayTrip from "@/composables/useDayTrip";
import useInsurance from "@/composables/useInsurance";
import { UserType } from "@/models/enums";
import { useBookingStore } from "@/store/booking";
import { useUserStore } from "@/store/user";
import { computed, defineComponent, onMounted, ref } from "vue";
import AgentCheckout from "./AgentCheckout.vue";

export default defineComponent({
	components: {
		BookingHeader,
		Details,
		Newsletter,
		Insurance,
		Charity,
		Terms,
		BaseSpinner,
		AgentCheckout,
	},
	setup() {
		const userStore = useUserStore();
		const bookingStore = useBookingStore();
		useCalculatePriceEffect();
		const { getCharity, charityConfig } = useCharity();
		const { getInsurances, insurances } = useInsurance();
		const { isDayTrip } = useDayTrip();

		const loading = ref(true);

		onMounted(() => {
			const promises: Promise<unknown>[] = [getCharity(), getInsurances()];

			Promise.all(promises)
				.then()
				.finally(() => (loading.value = false));
		});

		const isAmendment = computed(() => bookingStore.getBooking.amendmentMode);

		const isAgent = computed(() => userStore.getUserType === UserType.Agent);

		const showAdditionalDetails = computed(() => {
			return (
				!userStore.getIsTravelCardMember &&
				!bookingStore.getRouteIsFromIsland &&
				!isDayTrip.value &&
				!isAmendment.value
			);
		});

		return {
			showAdditionalDetails,
			charityConfig,
			insurances,
			loading,
			isAmendment,
			isAgent,
		};
	},
});
